import { useCallback } from 'react';

import { onAnalytics, ANALYTICS_TRIGGERS } from '@24i/nxg-sdk-smartott-shared/src/analytics';

import { BuildPlaybackEventFunction } from './buildPlaybackEvent';
import { PlaybackState } from './playbackState';
import { getAdType } from '../../utils';
import { AdPlayerEventParams } from '../../types';

export const useTriggerOnAdBuffering = (buildPlaybackEvent: BuildPlaybackEventFunction) => {
    const triggerOnAdBuffer = useCallback(
        (playbackState: PlaybackState | undefined, params: AdPlayerEventParams) => {
            const event = buildPlaybackEvent('AD_BUFFERING', playbackState);
            if (!event) return;

            const assetDuration = (playbackState?.asset?.duration ?? 0) * 1000;

            onAnalytics(ANALYTICS_TRIGGERS.AD_BUFFERING, {
                ...event,
                adId: params.adId,
                adName: params.adName,
                adPosition: getAdType(params.adPosition, assetDuration),
                adPlaybackPosition: Math.round(playbackState?.currentTime ?? 0),
                adDuration: params.adDuration,
                timestamp: params.timestamp,
            });
        },
        []
    );

    return triggerOnAdBuffer;
};
